import React from 'react';
import {
  Box,
  Link,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PublicPageLayout } from '../page-shell/public-page-layout';

const ErrorPage: React.FC = () => {
  const { t } = useTranslation('components', { keyPrefix: 'pages' });

  return (
    <PublicPageLayout showFooter>
      <Box
        sx={{
          px: 5,
          py: 6,
          textAlign: 'center',
        }}
      >
        <Typography
          gutterBottom
          fontWeight={700}
          variant='h5'
        >
          {t('page_not_found')}
        </Typography>
        <Typography
          gutterBottom
          color='text.secondary'
          variant='body1'
        >
          {t('page_not_found_detail')}
        </Typography>
        <Typography
          color='text.secondary'
          variant='body1'
        >
          <Link href='/#/'>
            {t('page_not_found_click_here')}
          </Link>
          &nbsp;
          {t('page_not_found_third_party_access_link')}
        </Typography>
      </Box>
    </PublicPageLayout>
  );
};

export default ErrorPage;
